import React from 'react'
import Paper from '@material-ui/core/Paper'
import moment from 'moment'


const styles = {
    marginLeft: '10px',
    eventItem: {
        border: '2px solid gray',
        boxShadow: '2px 2px 2px',
        padding: '2px',
        marginBottom: '8px',
        cursor: 'pointer',
        textAlign: 'center',
        //maxWidth: '800px'
    },
    myEvent: {
        backgroundColor: 'green',
        color: 'white',
        fontWeight: 'bold',
        padding: '1em'
    },
    del: {
        color: 'white',
        textWeight: 'bold',
        padding: '4px',
        marginLeft: '8px',
        backgroundColor: 'red',
        cursor  : 'pointer'
    },
    headline: {
        color: '#3f51b5'
    },
    red: {
        color: 'red',
        fontWeight: 'bold'
    }
}

const CanidateListItem = ({listItem, doToggleView, isMyEvent}) => {
    
    const renderTime = (timeRange, time) => {
        if(timeRange==='onDate') {
            if(time!=='Nach Vereinbarung') {
                return <h3 style={{color: 'red'}}>Uhrzeit: {time}</h3>
            } else {
                return <h3>Uhrzeit nach Vereinbarung</h3>
            }
        }
    }

    return (        
        <Paper key={listItem.data.id} style={styles.eventItems}>
            <div onClick={()=>doToggleView('canidateList', listItem)} style={styles.eventItem} >
                {listItem.data.timeRange==='onDate'
                    ? <h3 style={styles.red}>An einem bestimmten Datum</h3>
                    :  <h3>Nach Vereinbarung bis</h3>}
                <h3>{moment(listItem.data.date).format('dddd')+' '+ moment(listItem.data.date).format('L')} </h3>
                {renderTime(listItem.data.timeRange, listItem.data.time)}
                {listItem.data.pkw
                    ? <h3 style={{color: 'red'}}>PKW erforderlich</h3>
                    : null
                }
                <h3 style={{backgroundColor: '#eceff1'}}>{listItem.data.task}</h3>
                <h3>{listItem.data.ort}</h3>
                {isMyEvent
                    ?<div style={styles.myEvent}>Hilfe angeboten</div>
                    :null
                }
                
            </div> 
        </Paper>
    )
}

export default CanidateListItem


// WEBPACK FOOTER //
// ./src/Components/Canidates/CanidateListItem.js